import {
  Module,
  VuexModule,
  Action,
  Mutation,
  getModule
} from 'vuex-module-decorators'
import Vue from 'vue'
import axios from 'axios'

import store from '@/store'
import dashboardModule from '@/store/dashboard'
import whitelabelModule from '@/store/whitelabel'
import { Whitelabel } from '@/types/Whitelabel'

const name = 'dashboard'

@Module({
  namespaced: true,
  dynamic: true,
  name,
  store
})
class DashboardModule extends VuexModule {
  private currentMessage = ''
  private currentColor = 'success'
  private currentStatistics: any = {}

  private get whitelabel(): Whitelabel {
    return whitelabelModule.whitelabel
  }

  get message() {
    return this.currentMessage
  }

  get color() {
    return this.currentColor
  }

  get statistics() {
    return this.currentStatistics
  }

  @Mutation
  setMessage(payload: string) {
    this.currentMessage = payload
  }

  @Mutation
  setColor(payload: string) {
    this.currentColor = payload
  }

  @Mutation
  setCurrentStatistics(payload: any) {
    Vue.set(this, 'currentStatistics', payload)
  }

  @Action({ rawError: true })
  newError(payload: string) {
    this.context.commit('setColor', 'error')
    this.context.commit('setMessage', payload)
  }

  @Action({ rawError: true })
  newMessage(payload: string) {
    this.context.commit('setColor', 'success')
    this.context.commit('setMessage', payload)
  }

  @Action({ rawError: true })
  newInfo(payload: string) {
    this.context.commit('setColor', 'info')
    this.context.commit('setMessage', payload)
  }

  @Action({ rawError: true })
  resetMessage() {
    this.context.commit('setMessage', '')
  }

  @Action({ rawError: true })
  async fetchStatistics() {
    try {
      const { data } = await axios.get(
        `/admin/${this.whitelabel.slug}/meta/statistics`
      )
      this.context.commit('setCurrentStatistics', data)
    } catch (error) {
      dashboardModule.newError('Statistiken konnten nicht geladen werden')
    }
  }
}

export default getModule(DashboardModule)
